"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("../../../../utils/styles");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { theme, pxToEm, replacePXinStringWithEM, themeStyleHelper } from '../../../../utils/styles/index';

/* ++++++++++ --------------- EXPORT : TABLE : HEAD : STYLES --------------- ++++++++++ */


var _default = {
  head: {
    // see table_styles for more (variants can alter styles)
    position: 'relative',
    zIndex: '1',
    // ----- align ----- //
    '&.align-left': {
      textAlign: 'left'
    },
    '&.align-center': {
      textAlign: 'center'
    },
    '&.align-right': {
      textAlign: 'right'
    },
    '& .innerhead': {
      display: 'flex',
      '& .icon': {
        marginRight: (0, _styles.pxToEm)(3)
      },
      '&.isSortable-true': {
        cursor: 'pointer'
      }
    }
  }
};
exports.default = _default;